export default {
  namespaced: true,

  state: {
    product: null,
  },

  getters: {
    get: state => {
      return state.product;
    },
  },

  mutations: {
    set: (state, payload) => {
      state.product = payload;
    },
  },

  actions: {
    async init({commit}) {
      const product = await require('../../../assets/json/product.json');
      commit('set', product);

      console.log('dev store product load - completed');
    },
  },
};
